import {PROPERTY_AP_INSURANCE_KEY, PROPERTY_AP_JOB_KEY, PROPERTY_AP_LOYALTY_STATUS_KEY, PROPERTY_AP_NIN, PROPERTY_AP_PRACTITIONER_KEY, PROPERTY_AP_SOCIAL_ID_KEY} from '../helpers/properties'
import {LOYALTY_STATUSES} from '../helpers/misc'

export function getJobProperty(properties) {
  let res = null

  try {
    res = properties.find(({property_id}) => property_id === PROPERTY_AP_JOB_KEY).property_value[0].id
  } catch (e) {
    //silence
  }

  return res
}

export function getInsuranceCompany(properties) {
  let res = null

  try {
    res = properties.find(({property_id}) => property_id === PROPERTY_AP_INSURANCE_KEY).property_value[0].id
  } catch (e) {
    //silence
  }

  return res
}

export function getSocialId(properties) {
  let res = null

  try {
    res = properties.find(({property_id}) => property_id === PROPERTY_AP_SOCIAL_ID_KEY).property_value
  } catch (e) {
    //silence
  }

  return res
}

export function getPractitioner(properties) {
  let res = null

  try {
    res = properties.find(({property_id}) => property_id === PROPERTY_AP_PRACTITIONER_KEY).property_value
  } catch (e) {
    //silence
  }

  return res
}

export function getLoyaltyStatus(properties) {
  let res = null

  try {
    res = properties.find(({property_id}) => property_id === PROPERTY_AP_LOYALTY_STATUS_KEY).property_value

    if(res.length > 0 && LOYALTY_STATUSES.hasOwnProperty(res[0].name))
      return LOYALTY_STATUSES[res[0].name]

  } catch (e) {
    //silence
  }

  return res
}

export function getNationalId(properties) {
  let res = null

  try {
    res = properties.find(({property_id}) => property_id === PROPERTY_AP_NIN).property_value
  } catch (e) {
    //silence
  }

  return res
}

